module.exports = __webpack_public_path__ + "assets/new-relic.b8ab22c8.svg";